import * as $ from "jquery";

export default class PricesComponent {
    constructor() {
        this.componentSelector = "#ecom-orders";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('#js-resend-order').off().on('click', function () {
            instance.resendOrder(instance);
        });
    }

    resendOrder(instance) {
        let order = $('#ordernumber').val();

        if (order == "") {
            bootbox.alert("Du måste ange ett ordernummer.");
            return;
        }

        axios({
            method: 'post',
            url: "/orderapi/resendorder",
            data: { ordernumber: order }
        }).then(function (response) {
            console.log(response.data);
            $('#report').html(response.data);
        }).catch(function (response) {
            bootbox.alert("Inga order matchade sökningen.");
        });
    }
}